<template>
  <b-container>
  </b-container>
</template>
<script>
export default {
  name: 'MercadolibreIntegrationPage',
  components: {
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  beforeMount() {
    if (this.$route.query.code) this.setMeliIntegration()
    else this.$router.push({ name: 'search' })
  },
  methods: {
    setMeliIntegration() {
      let domain = new URL(window.location.href)
      this.$http.get(this.$appConfig.api.baseUrl + 'platforms/meli/authorize/' + this.$route.query.code)
        .then(response => {
          this.init()
            .then(() => {
              if (this.$universe && domain.hostname.indexOf(this.$universe.domain) === -1) {
                window.location.href = 'https://' + this.$universe.domain + '/company/integrations'
              } else {
                this.$router.push({ name: 'company-integrations' })
              }
            })
        }, err => {
          if (this.$universe && domain.hostname.indexOf(this.$universe.domain) === -1) {
            window.location.href = 'https://' + this.$universe.domain + '/company/integrations?error=' + err.body.message
          } else {
            this.$router.push({ name: 'company-integrations', query: { error: err.body.message } })
          }
        })
    }
  }
}
</script>
